const recordFilter = (e) => {
  e = e.replace(/^(rec)/g, "")
  return e
}

export default recordFilter;